import { Component, Input, Output, EventEmitter } from '@angular/core';


/**
   * Logger Factory
   * @namespace title: is the title to show inside the input 
   * @namespace inputLabelValue: is the value brought to his parent
  
*/

@Component({
  selector: 'ute-input-drawer',
  templateUrl: 'ute-input-drawer.component.html'
})
export class UteInputDrawerComponent {
  @Input()  isDrawerOpen: boolean;
  @Input()  cancel: boolean = false;
  @Input()  cancelLabel: string;
  @Input()  action: string;
  @Input()  actionLabel: string;
  @Input()  title: string;
  
  @Output() onClickAction = new EventEmitter;
  @Output() isDrawerOpenChange = new EventEmitter;
  @Output() inputLabelValue = new EventEmitter;

  constructor() {
   
  }

  ionViewDidLoad() {
    
  }

  onChangeDrawer(event){
    this.isDrawerOpenChange.emit(false);
  }
  onChangeInputLabel(event){
    this.inputLabelValue.emit(event);
  }

}


// WEBPACK FOOTER //
// ./src/app/components/commons/molecules/ute-input-drawer/ute-input-drawer.component.ts